import { api } from 'api'
import { createAsyncThunk } from 'modules/store'
import { normalizeApiUrl } from 'packages/helper'
import { downloadBlob } from 'utils/downloadBlob'

export const getAllTetrisLogs = createAsyncThunk('tetrisLogs/getAllTetrisLogs', async (_, { rejectWithValue }) =>
  api.tetrisLogs.getAll().catch((error) => rejectWithValue(error.message)),
)

export const getTetrisLogFile = createAsyncThunk(
  'tetrisLogs/getTetrisLogFile',
  async (filename: string, { rejectWithValue }) =>
    api.tetrisLogs
      .getLink(filename)
      .then((data) => api.tetrisLogs.download(normalizeApiUrl(data.link)))
      .then((data) => downloadBlob(data, filename))
      .catch((error) => rejectWithValue(error.message)),
)
